export const WAVEFORM_HEIGHT = 128;
